/* istanbul ignore file */

import { connect } from 'react-redux';
import { sendGAEvent } from '@noths/polaris-client-google-analytics';
import type { Dispatch } from 'redux';

import { ListingsControlsDrawer } from 'src/components/organisms/ListingsControlsDrawer/ListingsControlsDrawer';
import type { FacetCounts } from 'src/components/organisms/ListingsControlsOptions/types';
import type { ReduxApplicationState } from 'src/redux/combinedReducer';
import {
  selectActiveFacets,
  selectTotalActiveOptions,
} from 'src/redux/productsQuery/selectors/selectors';
import { actions } from 'src/redux/productsQuery/slice';
import { MODAL_CONTROLS_CLOSE, NO_MATCHING_PRODUCTS } from './copy';
import type {
  ListingsControlsDispatchProps,
  ListingsControlsDrawerStateProps,
} from './ListingsControlsDrawer';

const getModalCloseButtonText = (products: ReduxApplicationState['products']) => {
  if (products.error) {
    return MODAL_CONTROLS_CLOSE;
  }

  if (products.totalProducts === 0) {
    return NO_MATCHING_PRODUCTS;
  }

  return `View ${products.totalProducts} products`;
};

const mapStateToProps = (state: ReduxApplicationState): ListingsControlsDrawerStateProps => {
  const { products, productsQuery } = state;

  return {
    drawerCTAButtonText: getModalCloseButtonText(products),
    drawerOpen: productsQuery.isModalOpen,
    loading: products.pageLoading !== null,
    totalActiveFacets: selectActiveFacets(state).length,
    totalActiveFacetOptions: selectTotalActiveOptions(state),
  };
};

const mapDispatchToProps = (dispatch: Dispatch): ListingsControlsDispatchProps => {
  return {
    closeDrawer: () => dispatch(actions.closeModal()),
    onDrawerCTAButtonClick: ({ totalActiveFacetOptions, totalActiveFacets }: FacetCounts) => {
      sendGAEvent({
        event: 'custom_event',
        event_category: 'Filters',
        event_action: 'view results',
        event_label: `number of categories: ${totalActiveFacets}|number of filters: ${totalActiveFacetOptions}`,
      });
      dispatch(actions.closeModal());
    },
  };
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export const ListingsControlsDrawerContainer = connector(ListingsControlsDrawer);
